import { Store as notifyStore } from "react-notifications-component";
import { NotifyContent, tempOptions } from "components/Notify";
import { exportAuditLog } from "services/auditService";
import utils from "utils";

/**
 * Exports the audit log for `request` and saves the Excel file, for the export
 * dialog and the Audit log page alike. A failed export is told to the user.
 */
export default async function downloadAuditLogExport(request, t) {
  try {
    const exportResult = await exportAuditLog(request);
    if (!exportResult) return;
    const { blob, fileName } = exportResult;
    if (!blob) return;
    const url = globalThis.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName || "audit-log-export.xlsx");
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    utils.debug(error, utils.MSG_TYPE_ERR);
    notifyStore.addNotification({
      ...tempOptions,
      content: NotifyContent("danger", t("auditLog.exportFail")),
    });
  }
}
